import makeApiRequest from './makeApiRequest'


const apiRequest = makeApiRequest()

const _parseBarcode = (barcode) => {
    if (!barcode || typeof barcode !== 'string') {
        throw new Error('Barcode is invalid.')
    }

    return barcode.trim().replace(/#/g, '')
}

export const getListHistoriesByBarcode = async (barcode) => {
    const vBarcode = _parseBarcode(barcode)

    const {data} = await apiRequest({
        url: `/histories/${vBarcode}/histories`,
        method: 'GET',
    })

    return data
}

export const getListHistoriesByBarcodeV2 = async (barcode, payload) => {
    const vBarcode = _parseBarcode(barcode)
    const {data} = await apiRequest({
        url: `/histories/${vBarcode}/histories/v2`,
        method: 'POST',
        data: payload,
    })

    return data
}

export const pushNewItemHistory = async (barcode, event = {}) => {
    const vBarcode = _parseBarcode(barcode)

    const {data} = await apiRequest({
        url: `/histories/${vBarcode}`,
        method: 'POST',
        data: event
    })

    return data
}

